const prefix = "[Patients]";

const TYPES = {
  GET_PATIENTS: `${prefix} GET_PATIENTS`,
  GET_PATIENTS_SUCCESS: `${prefix} GET_PATIENTS_SUCCESS`,
  GET_PATIENTS_ERROR: `${prefix} GET_PATIENTS_ERROR`,
  PATIENTS_UI_REFRESH: `${prefix} PATIENTS_UI_REFRESH`,

  ADD_PATIENT_MODAL_SHOW: `${prefix} ADD_PATIENT_MODAL_SHOW`,
  ADD_PATIENT_MODAL_HIDE: `${prefix} ADD_PATIENT_MODAL_HIDE`,

  PATIENT_SAVE: `${prefix} PATIENT_SAVE`,
  PATIENT_DELETE: `${prefix} PATIENT_DELETE`,
  CURRENT_PATIENT_REFRESH: `${prefix} CURRENT_PATIENT_REFRESH`,

  SEARCH_PATIENTS_REFRESH: `${prefix} SEARCH_PATIENTS_REFRESH`,
  GET_SEARCH_PATIENTS: `${prefix} GET_SEARCH_PATIENTS`,
  GET_SEARCH_PATIENTS_SUCCESS: `${prefix} GET_SEARCH_PATIENTS_SUCCESS`,
  GET_SEARCH_PATIENTS_ERROR: `${prefix} GET_SEARCH_PATIENTS_ERROR`,
};

export const patientActions = {
  ...TYPES,
  getPatients: (payload) => ({
    type: TYPES.GET_PATIENTS,
    payload,
  }),
  getPatientsSuccess: (payload) => ({
    type: TYPES.GET_PATIENTS_SUCCESS,
    payload,
  }),
  getPatientsError: (error) => ({
    type: TYPES.GET_PATIENTS_ERROR,
    payload: error,
  }),
  patientsUIrefresh: (payload) => ({
    type: TYPES.PATIENTS_UI_REFRESH,
    payload,
  }),
  showAddPatientModal: () => ({
    type: TYPES.ADD_PATIENT_MODAL_SHOW,
  }),
  hideAddPatientModal: () => ({
    type: TYPES.ADD_PATIENT_MODAL_HIDE,
  }),
  patientSave: (data, id) => ({
    type: TYPES.PATIENT_SAVE,
    payload: { data, id },
  }),
  patientDelete: (id) => ({
    type: TYPES.PATIENT_DELETE,
    payload: { id },
  }),
  currentPatientRefresh: (patient) => ({
    type: TYPES.CURRENT_PATIENT_REFRESH,
    payload: patient,
  }),
  searchPatientsRefresh: (payload) => ({
    type: TYPES.SEARCH_PATIENTS_REFRESH,
    payload,
  }),
  getSearchPatients: (payload) => ({
    type: TYPES.GET_SEARCH_PATIENTS,
    payload: { search: payload },
  }),
  getSearchPatientsSuccess: (payload) => ({
    type: TYPES.GET_SEARCH_PATIENTS_SUCCESS,
    payload,
  }),
  getSearchPatientsError: () => ({
    type: TYPES.GET_SEARCH_PATIENTS_ERROR,
  }),
};
